export const nodeOutline = {
  main: { light: "#0A9396", dark: "#111313ff" }
};
